module.exports = __webpack_public_path__ + "static/img/4.67e6f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_image/4.jpg
// module id = RXNc
// module chunks = 39